// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmocForm_root__ocnUS .EmocForm_loading__e1Bck {
  display: flex;
  height: 160px;
  align-items: center;
  justify-content: center;
}
.EmocForm_root__ocnUS .label-optional {
  display: flex;
  justify-content: space-between;
}
.EmocForm_root__ocnUS .label-optional::after {
  opacity: 1;
  font-size: 11px;
  letter-spacing: 0.1px;
  color: #002bbc;
}
.EmocForm_root__ocnUS .EmocForm_details__QBPYP {
  font-size: 15px;
  letter-spacing: 0.1px;
  color: #575757;
  line-height: 1.6;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/EmocForm/EmocForm.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEE;EACE,aAAA;EACA,8BAAA;AAAJ;AACI;EACE,UAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AACN;AAEE;EACE,eAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAAJ","sourcesContent":[".root {\r\n  .loading {\r\n    display: flex;\r\n    height: 160px;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  :global(.label-optional) {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    &::after {\r\n      opacity: 1;\r\n      font-size: 11px;\r\n      letter-spacing: 0.1px;\r\n      color: #002bbc;\r\n    }\r\n  }\r\n  .details {\r\n    font-size: 15px;\r\n    letter-spacing: 0.1px;\r\n    color: #575757;\r\n    line-height: 1.6;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EmocForm_root__ocnUS`,
	"loading": `EmocForm_loading__e1Bck`,
	"details": `EmocForm_details__QBPYP`
};
export default ___CSS_LOADER_EXPORT___;
